export enum ReferralType {
  EMAIL = 'Email',
  LINKEDIN = 'LinkedIn',
  X = 'X'
}
